import { get } from '@webapp-next/lib/request/webapp/apiv2';

type PayrollEligibilityCheckResponse = {
  success: boolean;
  eligibility: boolean;
  addOnStatus: string;
  cancellationDate: string;
  provider: string;
};

export default async function getPayrollEligibilityCheck(): Promise<
  PayrollEligibilityCheckResponse
> {
  const { data } = await get('/api/payroll/v2/eligibility');

  return data || {};
}
